<template>
  <div id="app" class="container">
    <div id="logo-container">
      <p v-if="auth.user !== null">Logged in with {{ auth.user.email }}</p>
      <p v-else>not logged in</p>
      <a href="/">
        <img id="logo" src="./assets/logo.png">
      </a>
    </div>
    <div v-if="auth.loaded">
      <router-view></router-view>
    </div>
    <div v-else>
      <loading></loading>
    </div>
  </div>

</template>
<script>
import authService from './auth'
import Loading from './components/Loading.vue'

export default {
  name: 'app',
  data () {
    return {
      auth: authService
    }
  },
  components: {
    Loading
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /*text-align: center;*/
  color: #2c3e50;
  margin-top: 60px;
  margin-bottom: 60px;
}
#logo {
  height: 250px;
}
#logo-container {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// App.vue?fac4f88a